import { CircularProgress, Grid, Paper } from "@mui/material";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: "100vh",
    direction: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  gridItem: {
    width: "100%",
    padding: "1em",
    textAlign: "center",
  },
  paper: {
    padding: ".5em",
  },
}));

const Spinner = ({ message }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={0} className={classes.root}>
      <Grid item xs={12} className={classes.gridItem}>
        <Paper elevation={3} className={classes.paper}>
          <CircularProgress />
          <p>{message}</p>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Spinner;
